
    // this file was auto generated by python script
    import Tablet from './Tablet';
    export default Tablet;
    